import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import Login from "./login";
import ForgotPassword from "./forgot-password";
import UnlockPasswordPage from "./unlock-password";

const Public = () => {
  let { path } = useRouteMatch();
  return (
    <div className="app-public">
      <Switch>
        <Route path={`${path}/login`} component={Login} />
        <Route path={`${path}/forgot-password`} component={ForgotPassword} />
        <Route
          path={`${path}/unlock-password`}
          component={UnlockPasswordPage}
        />
      </Switch>
    </div>
  );
};

export default Public;
